var map = {
	"./Alfredo Sanzo.jpg": 6561,
	"./Débora Fortini.jpg": 5269,
	"./Fernando Dodino.jpg": 5217,
	"./Gisela Decuzzi.jpg": 4326,
	"./Guillermo Polito.jpg": 9236,
	"./Juan Lagostena.jpg": 1079,
	"./Lucas Spigariol.jpg": 4517,
	"./Mariana Matos.jpg": 2236,
	"./Micaela Pizarro.jpg": 2590,
	"./Nahuel Palumbo.jpg": 9904,
	"./Nicolás Passerini.jpg": 8790,
	"./Nicolás Scarcella.jpg": 9882,
	"./Pablo Tesone.jpg": 6875,
	"./Pablo de Haro.jpg": 6816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5342;